import Plyr from "plyr";
export default class AudioPlayer {
    static init() {
        const config = {
            i18n: this.getTranslations(),
            controls: [
                'play',
                'progress',
                'current-time',
                'mute',
                'volume',
                'settings',
            ],
            disableContextMenu: true
        }

        Array.from(document.querySelectorAll('.audio-player')).forEach(el => {
            new Plyr(el.querySelector('audio'), config);
            el.classList.add('audio-player--is-initialized');
        });
    }

    static getTranslations() {
        const translations = {
            cs: {
                restart: 'Restartovat',
                rewind: 'Zpět o {seektime}s',
                play: 'Přehrát',
                pause: 'Pozastavit',
                fastForward: 'Vpřed o {seektime}s',
                seek: 'Posunout',
                seekLabel: '{currentTime} z {duration}',
                played: 'Přehráno',
                buffered: 'Načteno',
                currentTime: 'Aktuální čas',
                duration: 'Délka',
                volume: 'Hlasitost',
                mute: 'Ztlumit',
                unmute: 'Zapnout zvuk',
                enableCaptions: 'Zapnout titulky',
                disableCaptions: 'Vypnout titulky',
                enterFullscreen: 'Celá obrazovka',
                exitFullscreen: 'Ukončit celou obrazovku',
                frameTitle: 'Přehrávač pro {title}',
                captions: 'Titulky',
                settings: 'Nastavení',
                menuBack: 'Zpět do předchozího menu',
                speed: 'Rychlost',
                normal: 'Normální',
                quality: 'Kvalita',
                loop: 'Opakovat',
                start: 'Začátek',
                end: 'Konec',
                all: 'Vše',
                reset: 'Obnovit',
                disabled: 'Zakázáno',
                enabled: 'Povoleno',
                advertisement: 'Reklama',
                qualityBadge: {
                    2160: '4K',
                    1440: 'HD',
                    1080: 'HD',
                    720: 'HD',
                    576: 'SD',
                    480: 'SD'
                }
            },
            de: {
                restart: 'Neu starten',
                rewind: 'Um {seektime} Sekunden zurückspulen',
                play: 'Play',
                pause: 'Pause',
                fastForward: 'Um {seektime} Sekunden vorspulen',
                seek: 'Suchen',
                seekLabel: '{currentTime} von {duration}',
                played: 'Abgespielt',
                buffered: 'zwischengespeichert',
                currentTime: 'Aktuelle Zeit',
                duration: 'Dauer',
                volume: 'Lautstärke',
                mute: 'Ton ausschalten',
                unmute: 'Ton einschalten',
                enableCaptions: 'Untertitel einblenden',
                disableCaptions: 'Untertitel ausblenden',
                enterFullscreen: 'Vollbild einschalten',
                exitFullscreen: 'Vollbild ausschalten',
                frameTitle: 'Player für {title}',
                captions: 'Untertitel',
                settings: 'Einstellungen',
                menuBack: 'Gehe zurück zum vorherigen Menü',
                speed: 'Geschwindigkeit',
                normal: 'Normal',
                quality: 'Qualität',
                loop: 'Wiederholen',
                start: 'Start',
                end: 'Ende',
                all: 'Alle',
                reset: 'Zurücksetzten',
                disabled: 'Deaktiviert',
                enabled: 'Aktiviert',
                advertisement: 'Werbung',
                qualityBadge: {
                    2160: '4K',
                    1440: 'HD',
                    1080: 'HD',
                    720: 'HD',
                    576: 'SD',
                    480: 'SD'
                }
            },
            en: {
                restart: 'Restart',
                rewind: 'Rewind {seektime}s',
                play: 'Play',
                pause: 'Pause',
                fastForward: 'Forward {seektime}s',
                seek: 'Seek',
                seekLabel: '{currentTime} of {duration}',
                played: 'Played',
                buffered: 'buffered',
                currentTime: 'Current time',
                duration: 'Duration',
                volume: 'Volume',
                mute: 'Mute',
                unmute: 'Unmute',
                enableCaptions: 'Enable captions',
                disableCaptions: 'Disable captions',
                enterFullscreen: 'Enter fullscreen',
                exitFullscreen: 'Exit fullscreen',
                frameTitle: 'Player for {title}',
                captions: 'Captions',
                settings: 'Settings',
                menuBack: 'Go back to previous menu',
                speed: 'Speed',
                normal: 'Normal',
                quality: 'Quality',
                loop: 'Loop',
                start: 'Start',
                end: 'End',
                all: 'All',
                reset: 'Reset',
                disabled: 'Disabled',
                enabled: 'Enabled',
                advertisement: 'Ad',
                qualityBadge: {
                    2160: '4K',
                    1440: 'HD',
                    1080: 'HD',
                    720: 'HD',
                    576: 'SD',
                    480: 'SD'
                }
            },
            ro: {
                restart: 'Repornește',
                rewind: 'Derulează înapoi {seektime}s',
                play: 'Redă',
                pause: 'Pauză',
                fastForward: 'Derulează înainte {seektime}s',
                seek: 'Derulează',
                seekLabel: '{currentTime} din {duration}',
                played: 'Redat',
                buffered: 'Încărcat',
                currentTime: 'Timp curent',
                duration: 'Durată',
                volume: 'Volum',
                mute: 'Oprește sunetul',
                unmute: 'Pornește sunetul',
                enableCaptions: 'Activează subtitrările',
                disableCaptions: 'Dezactivează subtitrările',
                enterFullscreen: 'Intră în modul ecran complet',
                exitFullscreen: 'Ieși din modul ecran complet',
                frameTitle: 'Player pentru {title}',
                captions: 'Subtitrări',
                settings: 'Setări',
                menuBack: 'Întoarce-te la meniul anterior',
                speed: 'Viteză',
                normal: 'Normal',
                quality: 'Calitate',
                loop: 'Repetă',
                start: 'Început',
                end: 'Sfârșit',
                all: 'Totul',
                reset: 'Resetează',
                disabled: 'Dezactivat',
                enabled: 'Activat',
                advertisement: 'Reclamă',
                qualityBadge: {
                    2160: '4K',
                    1440: 'HD',
                    1080: 'HD',
                    720: 'HD',
                    576: 'SD',
                    480: 'SD'
                }
            }
        };
        const lang = document.querySelector('html').getAttribute('lang');
        if (lang === 'de' || lang === 'de-DE') {
            return translations.de;
        }
        if (lang === 'cs_CZ') {
            return translations.cs;
        }
        if (lang === 'ro_RO') {
            return translations.ro;
        }
        return translations.en
    }
}

AudioPlayer.init();
